import { useEditor, useNode } from "@craftjs/core";
import { Col, Switch } from "antd";
import { Form, Input } from "components/Form";
import "easymde/dist/easymde.min.css";
import React, { useEffect, useState } from "react";
import { BsMarkdown } from "react-icons/bs";
import IntlMessages from "util/IntlMessages";
import { MyMarkdown } from "@/routes/system/FormSetup/components/SfMarkdown";
import { deleteButton, EditorCollector, getId, NodeCollector, registerComponent, SpLayoutSetting, SpStyleSetting, syncPageState, updatePageState } from "@/routes/system/PageSetup/components/common";

const SpMarkdownSetting = () => {
  return (
    <>
      <Form.Item name="staticContent" label="content">
        <Input.TextArea className="item-property" />
      </Form.Item>
      <Form.Item name="readOnly" label="read-only" valuePropName="checked">
        <Switch className="item-property"/>
      </Form.Item>
      <SpStyleSetting />
      <SpLayoutSetting />
    </>
  )
}

export const SpMarkdown = ({ ...props }) => {
  const { actions: {setProp}, connectors: { connect, drag }, selected, style } = useNode(NodeCollector);
  const { actions, selectedNode } = useEditor(EditorCollector);
  const dbtn = deleteButton(selected, selectedNode, actions)
  const onChange = (value) => {
    setProp(props => {
      props.staticContent = value;
    });
  }
  return (
    <SppMarkdown doRef={ref => connect(drag(ref))} dbtn={dbtn} onChange={onChange} {...props} selectedStyle={style} />
  )
}

export const SppMarkdown = ({
  doRef, selectedStyle, dbtn, onChange, staticContent, readOnly,
  pageKey, itemKey, pageState, setPageState, ...otherProps }) => {
  let style = otherProps.style || {};
  style = { ...style, ...selectedStyle };
  const props = { ...otherProps, style }
  const [myValue, setMyValue] = useState(staticContent)

  useEffect(() => {
    syncPageState({itemKey, myValue, setMyValue, pageState, setPageState})
  },[itemKey, myValue, pageState, setPageState])

  const onMyChange = (myValue) => {
    updatePageState({itemKey, myValue, setMyValue, pageState, setPageState})
  }
  return (
    <Col ref={doRef} {...props}>
      <MyMarkdown readOnly={readOnly} value={myValue} onChange={onMyChange}/>
      {dbtn}
    </Col>
  );
}
SppMarkdown.enablePageState = true;

SpMarkdown.craft = {
  displayName: "Markdown",
  rules: {
    canMoveIn: function (incomingNode, currentNode) {
      return false;
    }
  },
  related: {
    settings: SpMarkdownSetting
  }
}

registerComponent({
  key: "SpMarkdown",
  component: SpMarkdown,
  runtimeComponent: SppMarkdown,
  template: <SpMarkdown itemKey={getId('markdown')} className="sp-markdown" span={24}/>,
  title: <IntlMessages id="system.page.library.markdown" text="Markdown Editor" />,
  icon: <BsMarkdown className="react-icons icon-bs"/>,
  type: "Component",
  subtype: "input",
  sequence: 15,
});

export default SpMarkdown;